export default __webpack_public_path__ + "static/media/Poppinsregular.7ce8abe5.woff";